mutation unbindSmppSession($session: SmppSessionWithProductDetailsInput) {
  unbindSmppSession(session: $session)
}
